import { Switch } from '@mm/components';
import { Tooltip } from 'antd';
import React from 'react';
import styles from './EnrichButton.module.css';

export const EnrichButton = () => (
  <div className={styles.container}>
    Enrich X-Ray Leads
    <Tooltip
      title="X-Ray leads will be enriched with consumer information FREE until March 1"
      placement="bottom"
    >
      <div className={styles.switch}>
        <Switch checked />
      </div>
    </Tooltip>
  </div>
);
